import { useEffect } from "react";
import FormCard from "../../../../../Lib/FormCard";
import FormInput from "../../../../../Lib/FormInput";
import FormSelect from "../../../../../Lib/FormSelect";

const ReservationDetails = ({
  formData,
  handleChange,
  isViewOnly = false,
  isEditingMode = false,
}) => {
  const bookingTypeOptions = [
    { value: "corporate", label: "Corporate" },
    { value: "individual", label: "Individual" },
    { value: "group", label: "Group" },
  ];
  const bookingStatusOptions = [
    { value: "check_in", label: "Check In" },
    { value: "booked", label: "Booked" },
    ...(isViewOnly || isEditingMode
      ? [
          {
            value: "cancelled",
            label: "Cancelled",
          },
        ]
      : []),
  ];
  const bookingSourceOptions = [
    { value: "Offline Booking", label: "Offline Booking" },
    { value: "Online Booking", label: "Online Booking" },
    { value: "Travel Agent", label: "Travel Agent" },
  ];
  useEffect(() => {
    if (formData.check_in_date_time) {
      const now = new Date(); // current local datetime
      const checkIn = new Date(formData.check_in_date_time); // parse input to Date

      const newStatus = checkIn > now ? "booked" : "check_in";

      // Only update if status is different
      if (formData.booking_status !== newStatus) {
        handleChange({
          target: { name: "booking_status", value: newStatus },
        });
      }
    }
  }, [formData.check_in_date_time]);

  return (
    <FormCard title="Reservation Details">
      <div className="form-container">
        <div className="row">
          <div className="col-md-4">
            <FormInput
              type="datetime-local"
              label="Check In"
              name="check_in_date_time"
              value={formData.check_in_date_time || ""}
              // value={toDateTimeLocal(formData.check_in_date_time)}
              onChange={handleChange}
              required
              disabled={isViewOnly}
              // restrictPast
            />
            {/* {formData.check_in_date_time && (
              <small className="text-muted">
                UTC: {new Date(formData.check_in_date_time).toLocaleString()} |
                IST: {formatTimeForDisplay(formData.check_in_date_time)}
              </small>
            )} */}
          </div>
          <div className="col-md-4">
            <FormInput
              type="datetime-local"
              label="Check Out"
              name="check_out_date_time"
              value={formData.check_out_date_time || ""}
              // value={toDateTimeLocal(formData.check_out_date_time)}
              onChange={handleChange}
              required
              disabled={isViewOnly}
              // restrictPast
            />
            {/* {formData.check_out_date_time && (
              <small className="text-muted">
                UTC: {new Date(formData.check_out_date_time).toLocaleString()} |
                IST: {formatTimeForDisplay(formData.check_out_date_time)}
              </small>
            )} */}
          </div>
          <div className="col-md-4">
            <FormInput
              type="text"
              label="Purpose of Visit"
              name="purpose_of_visit"
              value={formData.purpose_of_visit || ""}
              onChange={handleChange}
              placeholder="Purpose of Visit"
              disabled={isViewOnly}
            />
          </div>
          {/* <div className="col-md-4">
            <FormInput
              type="text"
              label="Arrival From"
              name="arrival_from"
              value={formData.arrival_from || ""}
              onChange={handleChange}
              placeholder="Arrival From"
              disabled={isViewOnly}
            />
          </div> */}
        </div>

        <div className="row">
          <div className="col-md-3">
            <FormSelect
              label="Booking Type"
              name="booking_type"
              options={bookingTypeOptions}
              value={formData.booking_type || ""}
              onChange={handleChange}
              required
              disabled={isViewOnly}
            />
          </div>
          {/* <div className="col-md-4">
            <FormInput
              type="text"
              label="Booking Reference No."
              name="booking_reference_no"
              value={formData.booking_reference_no || ""}
              onChange={handleChange}
              placeholder="Booking Reference No."
              disabled={isViewOnly}
            />
          </div> */}
          <div className="col-md-3">
            <FormSelect
              label="Booking Status"
              name="booking_status"
              options={bookingStatusOptions}
              value={formData.booking_status || ""}
              onChange={handleChange}
              disabled={isViewOnly}
            />
          </div>
          <div className="col-md-3">
            <FormSelect
              label="Booking Source"
              name="booking_source"
              options={bookingSourceOptions}
              value={formData.booking_source || ""}
              onChange={handleChange}
              disabled={isViewOnly}
            />
          </div>
          <div className="col-md-3">
            <FormInput
              type="text"
              label="Agent Name"
              name="agent_name"
              value={formData.agent_name || ""}
              onChange={handleChange}
              placeholder="Agent Name"
              disabled={isViewOnly}
            />
          </div>
        </div>
      </div>
    </FormCard>
  );
};

export default ReservationDetails;
